<template>
  <div id='find-out-more-pro'>
    <div class='row no-gutters' style='padding-left:25px'>
      <div ><img @click='back' class='icon' src='/static/img/back_arrow.png' alt=''/></div>
      <div class='header' v-html="$t('app.findOutMoreProPopup.title')">
      </div>
    </div>
    <div class='find-out-scrollable-content'>
      <spreadsheet class='spreadsheet' :needSubtitleInfo="true" :needTitle='false'></spreadsheet>
      <div class='policy-info'>
        <p>
        {{getPolicy}}
        </p>
      </div>
      <div class='line'></div>
    </div>
    <div class='button-section'>
      <div class="try-free">
        <span v-html="buttonLabel"></span>
      </div>
      <div class='col-12' style='padding: 0 62px'>
        <div class="row no-gutters" :style='hasDiscount ? "position:relative" : ""'>
          <rounded-button
            class="start-free-trial"
            :text="okBtnText"
            :isTextVhtml="isOkButtonTextHtml"
            :fontSize="'16px'"
            :fontWeight="'bold'"
            :color="'#fab62f'"
            :isOutline="false"
            @roundedButtonClicked="roundedButtonClicked"
          />
          <discount-label v-if='hasDiscount' :text="discountPercentAge" :rotateValue='5' :textColor="'#333333'" :padding='"0 0 0 10px"' :labelHeight="31" :labelWidth="75" :rightSideBackgroundColor='"white"' :isRotated="true" :isLeftSide="false" class='label' />
        </div>
      </div>
      <div class="col-12" style="padding: 0 82px">
        <div :class="'hr-sect mb-0 uppercase or-text'">{{$t('app.findOutMoreProPopup.or')}}</div>
      </div>
      <div class='col-12'>
        <inline-link
          :text="$t('app.findOutMoreProPopup.skipFreeTrialInlineLink')"
          :isDisabled="false"
          :color="'#ffffff'"
          class="inline-link"
          @inlineLinkClicked="inlineLinkClicked"
        />
      </div>
    </div>

  </div>
</template>

<script>
import BasicVsProSpreadSheet from '@/components/modules/shop/components/BasicVsProSpreadSheet';
import RoundedButton from '@/components/shared/elements/buttons/RoundedButton';
import InlineLink from '@/components/shared/elements/buttons/InlineLink';
import DiscountLabel from '@/components/shared/elements/modal/DiscountLabel';
import IslandLevelUpModal from '@/components/modules/island/components/IslandLevelUpModal';

export default {
    name: 'FindOutMorePro',
    components: {
      'rounded-button': RoundedButton,
      spreadsheet: BasicVsProSpreadSheet,
      InlineLink,
      DiscountLabel,
    },
    props: {
        level: {
          type: [String, Number],
          required: false,
          default: 0,
        },
        okBtnText: {
          type: String,
          required: true,
          default: '',
        },
        okAction: {
          type: Function,
          required: true,
        },
        buttonLabel: {
          type: String,
          required: true,
        },
        hasDiscount: {
          type: Boolean,
          required: true,
        },
        discountPercentAge: {
          type: String,
          required: true,
        },
        isOkButtonTextHtml: {
          type: Boolean,
          required: false,
          default: false,
        },
        product: {
          type: Object,
          required: true,
        },
        countryPrice: {
          type: String,
          required: true,
        },
    },
    computed: {
      getPolicy() {
        return this.$t('app.findOutMoreProPopup.policy', { countryPrice: this.countryPrice,
price: this.product.displayPrice(),
        period: this.product.renewMonthPeriod == 12 ? this.$t('app.product.periodOfTime.year') :
                this.product.renewMonthPeriod == 1200 ? this.$t('app.product.periodOfTime.lifetime') :
                this.product.renewMonthPeriod == 1 ? this.$t('app.product.periodOfTime.month') :
                this.$t('app.product.periodOfTime.monthsWithPeriodValue', { period: this.product.renewMonthPeriod }) });
      },
    },
    methods: {
      back() {
        this.$eventBus.closeModal();
          // if(this.proPopupType != undefined){
          //   setTimeout(()=>{
          //     this.$eventBus.$emit('ClickedProPopup', {
          //       type: this.proPopupType,
          //     });
          //   },500);
          // }else{
          //   setTimeout(() =>{
          //     this.$eventBus.showModal({
          //       bind: {
          //         is: IslandLevelUpModal,
          //         level: this.level,
          //         okText: this.returnText,
          //       },
          //       customClass: 'island-level-up-modal',
          //     });
          //   },500)
          // }
      },
      roundedButtonClicked() {
        this.okAction();
      },
      inlineLinkClicked() {
        this.$eventBus.closeModal();
      },
    },
};
</script>

<style lang='scss' scoped>
#find-out-more-pro{
  width: 556px;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.16);
  background-image: linear-gradient(to top, var(--primaryBlue), #24587c);
  overflow: hidden;
  padding-top: 23px;

  .find-out-scrollable-content{
    margin-left: 25px;
    margin-top: 8px;
    height: 300px;
    position: relative;
    width: 560px;
    padding-right: 30px !important;
    overflow-y: scroll;
  }
  .header{
    /deep/ div{
      font-family: Roboto;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.4;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
      padding-right: 62px;
      padding-left: 62px;
      width: 394px;
      margin-left: 33px;
    }

    /deep/ img{
      border-radius: 2px;
      width: 60.5px;
      height: 25.4px;
    }
  }
  .line{
    background-image: linear-gradient(to bottom, rgba(42, 102, 143, 0), rgba(52, 118, 165, 0.48) 28%, #3788bf);
    width: 557px;
    height: 37px;
    position: fixed;
    bottom: 182px;
    right: 0;
  }

  .icon{
    cursor: pointer;
    pointer-events: unset;
  }
  .spreadsheet{
    width: 509px;
  }

  .button-section{
    min-height: 165px;
    background-color: #3788BF;

    .start-free-trial{
        width: 432px;
        height: 44px;
      /deep/ .btn-text {
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
    .try-free{
      width: 392px !important;
      margin: 0 auto;
      padding-top: 22.7px;
      padding-bottom: 8.3px;
      font-family: Roboto;
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
      span{
        min-height: 30px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      }
    }
  }

    .hr-sect {
    font-family: Roboto;
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: #868686;
    margin: 15px 0 8px 0px;
    font-size: 10px;
    font-weight: 500;
  }
  .hr-sect::before,
  .hr-sect::after {
    content: "";
    flex-grow: 1;
    background-color: var(--white);
    height: 1px;
    font-size: 0px;
    line-height: 0px;
  }
  .hr-sect::after {
    margin-left: 8px;
  }
  .hr-sect::before {
    margin-right: 8px;
  }

  .or-text{
    font-family: Roboto;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: center;
    color: var(--white);
  }

  .inline-link{
    padding-top: 14px;
    padding-bottom: 16px;
    display: flex;
    justify-content: center;
  }

  .policy-info{
    padding-top: 10px;
    padding-bottom: 26px;
    width: 509px;
    p{
      width: 432px;
      margin: 0 auto;
      font-family: Roboto;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.57;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
    }
  }
}
   .label{
    position: absolute;
    top: -12px;
    right: -37px;
  }

</style>
